import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alerta-empresa',
  templateUrl: './alerta-empresa.component.html',
  styleUrls: ['./alerta-empresa.component.scss']
})
export class AlertaEmpresaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
